import callApi from 'utils/callApi';

// Requests
export function requestCreateSchedule(payload) {
  return callApi('settings/facility_schedule/', 'POST', payload);
}

export function requestUpdateSchedule(payload) {
  return callApi('settings/facility_schedule/', 'PATCH', payload);
}



// WEBPACK FOOTER //
// ./src/redux/modules/schedule.js